module.exports = __webpack_public_path__ + "img/Icoon_boek.ae40fc89.png";